import React from 'react';
import './Skills.css'

const Skills = () => {
    return (
        <div>

            <section id="skills" className="skills section-bg text-white">
                <div className="container" data-aos="fade-up">
                    <div className="section-title">
                        <h2>Skills</h2>
                        <p>
                            These are the technologies and programming languages which I learned
                        </p>
                    </div>
                    <div className="row skills-content">
                        <div className="col-lg-6">
                            <div className="progress">
                                <span className="skill">HTML <i className="val">85%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="85"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                            <div className="progress">
                                <span className="skill">CSS <i className="val">80%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="80"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">TailwindCSS <i className="val">70%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="70"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Bootstrap / React Bootstrap <i className="val">80%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="80"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">JavaScript <i className="val">55%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="55"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                            <div className="progress">
                                <span className="skill">React <i className="val">65%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="65"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Material UI <i className="val">60%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="60"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">

                            <div className="progress">
                                <span className="skill">React Router <i className="val">70%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="70"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                            <div className="progress">
                                <span className="skill">Node <i className="val">40%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="40"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Express <i className="val">60%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="60"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Firebase <i className="val">60%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="60"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                            <div className="progress">
                                <span className="skill">MongoDB <i className="val">55%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="55"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Git &amp; Github<i className="val">65%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="65"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>

                            <div className="progress">
                                <span className="skill">Rest API<i className="val">75%</i></span>
                                <div className="progress-bar-wrap">
                                    <div
                                        className="progress-bar"
                                        role="progressbar"
                                        aria-valuenow="65"
                                        aria-valuemin="0"
                                        aria-valuemax="100"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Skills;